import { Paper } from '@mui/material';
import { styled } from '@mui/system';

export const CustomPaper = styled(Paper)(({ theme }) => ({
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)', // Custom shadow
  borderRadius: '0', // Custom border radius
  overflow: 'hidden', // Hide any overflow at the paper level
  '& .MuiAutocomplete-listbox': {
    padding: 0,
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#bdbdbd',
      borderRadius: '3px',
    },
    '& .MuiAutocomplete-option': {
      padding: '0 12px',
      overflow: 'visible',
      position: 'relative',
      minHeight: '42px'
    }
  }
}));